export default __webpack_public_path__ + "static/media/rook_white.ba9ac487.svg";